<template>
  <v-form @submit="saveUserRole" onSubmit="return false;">
    <v-card>
      <v-card-title class="headline py-2">
        Назначить роль
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" class="mx-0"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      
      <v-card-text>
        <v-container grid-list-lg class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-select
                :error-messages="veeErrors.collect('role')" v-validate="'required'" data-vv-name="role" required data-vv-as="'Роль'"
                :items="all_roles" label="Назначить роль" item-value="id" item-text="name" v-model="role" return-object no-data-text="Нет доступных полей"></v-select>
            </v-flex>
            
            <v-divider></v-divider>
            <v-flex xs12 class="py-0 my-0">
              <span>Найти пользователя</span>
            </v-flex>
            <v-flex xs6>
              <v-text-field label="Email или ФИО" append-icon="search" @click:append="()=>findUser()" v-model="search"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-select
                :error-messages="veeErrors.collect('post')" v-validate="'required'" data-vv-name="post" required data-vv-as="'Пользователь'"
                :items="users" label="Пользователи" item-text="fullname" item-value="id" v-model="post" return-object no-data-text="Пользователи отсутствуют">
                <template slot="item" slot-scope="data">
                  <template>
                    <v-list-tile-avatar v-if="data.item.photo">
                      <img :src="data.item.photo">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.fullname"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-select>
            </v-flex>
            
          </v-layout>
        </v-container>
      </v-card-text>
  
      <v-divider></v-divider>
      <v-card-actions class="pa-3">
        <v-btn color="success" @click.prevent="saveUserRole" type="submit" :disabled="status.btnDisabled">Назначить</v-btn>
        <span :class="status.className" class="ml-2">{{status.text}}</span>
      </v-card-actions>

    </v-card>
  </v-form>
</template>

<script>
  export default {
    name : 'NewUserForm',
    
    computed:{
      all_roles(){
        return [{
          id:"",
          name:"Индивидульный набор",
          personal:1,
          type:0,
        }].concat(this.roles)
      }
    },
    
    props:{
      roles:{
        type: Array,
        required: true
      }
    },
    
    data() {
      return {
        search: '',
        post: '',
        role: {
          id:"",
          name:"Индивидульный набор",
          personal:1,
          type:0,
        },
        users: [],
        status:{
          btnDisabled: false,
          text: '',
          className:'green--text darken-1'
        }
      }
    },
    
    methods : {
      closeDialog(){
        this.$emit('close-dialog')
      },
      
      findUser(){
        this.$store.dispatch('orgstructure/anketa/findUser', this.search).then(response => {
          this.users = response.users
        })
      },
      
      saveUserRole(){
        
        
        this.$validator.validateAll().then( result => {
          if (result) {
            this.status={ btnDisabled: true, text: 'Сохранение', className:'grey--text lighten-1' }
            this.$store.dispatch('orgstructure/interfaces/attachSystem', { post_id: this.post.id, role_id: this.role.id }).then( response => {
              this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
              this.post.role_id = response.role_id
              this.$emit('save', {post: this.post, role: this.role})
            }).catch( error => {
              this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
            })
            return
          }
        })
        return false
      }
    }
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/apps/org/components/Roles/NewUserForm.vue